import TeamLogo from "@/components/team/logo";
import { formatOdd } from "@/utils";
import { empty } from "@/utils";
import { useOddsFormat } from "@/utils/providers/odds-format";
import { GameAlignmentType, LineType, Odd2, OddOutcome, TeamBasic, formatOddOutcomeShort } from "common";
import React from "react";

export default function GameTableOddOutcome({
  odd,
  winningTeam = null,
}: {
  odd?: Odd2;
  winningTeam: TeamBasic | null;
}) {
  const { oddsFormat } = useOddsFormat();
  if (odd !== undefined) {
    if (odd.outcome === OddOutcome.Push && !winningTeam) {
      odd.alignment = GameAlignmentType.Home
    }
    const formattedOdd = formatOdd(oddsFormat, odd, true);
    return (
      <div className="flex flex-row gap-2 items-center text-title-sm-medium">
        {odd.outcome !== undefined &&
          (odd.type === LineType.Spread || odd.type === LineType.Moneyline) && (
            <>
              {(winningTeam && odd.outcome !== OddOutcome.Push) ? (
                <TeamLogo size="xs" team={winningTeam} />
              ) : (
                <span className="font-bold uppercase">
                  {formatOddOutcomeShort(odd.outcome)}
                </span>
              )}
            </>
          )}
        <span>
          {(formattedOdd?.type === LineType.Moneyline
            ? formattedOdd?.payout
            : formattedOdd?.value) || empty()}
        </span>
      </div>
    );
  }
  return empty();
}
